





























import { Component, Vue } from 'vue-property-decorator';
import {mapGetters} from "vuex";
import ModalFooter from './ModalFooter.vue';


@Component({
    components: {ModalFooter},
    computed: {
        ...mapGetters(['getUser'])
    },
})
export default class Footer extends Vue {
    getUser!: any[];
    data(){
        return {
            privacyPolicyURI: location.origin + `/assets/media/pdf/Politica_de_Privacidad_v2_sichern.pdf`
        }
    }
}
